// assets/cart-gbg-preview.js
(function () {
  const LS_KEY = "gbgPreviewCache:v3";
  const cache = (() => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "{}"); }
    catch { return {}; }
  })();
  function saveCache(){ try{ localStorage.setItem(LS_KEY, JSON.stringify(cache)); }catch{} }

  function styleVariants(raw){
    const base = String(raw||"").toLowerCase().replace(/&/g,"and").replace(/[^a-z0-9\s-]/g," ").replace(/\s+/g," ").trim();
    const under = base.replace(/\s+/g,"_");
    const dash  = base.replace(/\s+/g,"-");
    return Array.from(new Set([under, dash, base]));
  }
  function normalizeStyleForFilename(raw){
    const t = String(raw||"").toLowerCase();
    const has = s => t.indexOf(s)>=0;
    if (has("equal") && has("lite")) return "equal_lite";
    if ((has("4")||has("four")) && has("lite") && has("tall")) return "4_lite_tall";
    if ((has("9")||has("nine")) && has("lite") && (has("prairie")||has("prarie"))) return "9_lite_prairie";
    if (t.indexOf("prarie")>=0) return "9_lite_prairie";
    return styleVariants(raw)[0] || "equal_lite";
  }
  function normalizeGridPattern(s){
    if(!s) return null;
    let t = String(s).toLowerCase();
    t = t.replace(/\s*x\s*/g,"x").replace(/\s+/g,"").replace(/[^0-9whx]/g,"");
    t = t.replace(/(\d+)wx(\d+)h/,"$1w$2h").replace(/(\d+)w(\d+)h/,"$1w$2h");
    return t || null;
  }
  function gridTo2x2(slug){
    const m = (slug||"").match(/(\d+)w(\d+)h/);
    return m ? `${m[1]}x${m[2]}` : null;
  }

  function primaryName(gridSlug, styleRaw){
    const g2x2 = gridTo2x2(gridSlug) || gridSlug;
    const st   = normalizeStyleForFilename(styleRaw);
    return `${g2x2}_${st}.jpg`;
  }
  function fallbackNames(gridSlug, styleRaw){
    const g2x2 = gridTo2x2(gridSlug);
    const grids = [g2x2, gridSlug].filter(Boolean);
    const st0 = normalizeStyleForFilename(styleRaw);
    const styles = Array.from(new Set([st0, ...styleVariants(styleRaw)]));
    const bases = [];
    for(const g of grids){
      for(const st of styles){
        bases.push(`${g}_${st}`, `${g}-${st}`, `${g} ${st}`);
      }
    }
    const uniq = Array.from(new Set(bases));
    const out  = [];
    for(const b of uniq){
      out.push(b);
      out.push(b.toLowerCase());
      out.push(b.split(/[\s-_]/).map(s=>s? (s[0].toUpperCase()+s.slice(1)) : s).join("_"));
    }
    const exts = ["jpg","jpeg","png","webp","gif","JPG","JPEG","PNG","WEBP","GIF"];
    const cands = [];
    for(const b of out) for(const e of exts) cands.push(`${b}.${e}`);
    const primary = primaryName(gridSlug, styleRaw);
    return cands.filter(n=> n !== primary);
  }

  function withWidth(url, box){
    const w = Math.max(80, Math.min(600, Math.round((box.clientWidth||110)*2)));
    return url + (url.includes("?") ? `&width=${w}` : `?width=${w}`);
  }


  // 直接載入 Liquid 產生的 Shopify Files 版本化 URL（包含目前的 ?v= 版本碼）
  function loadDirectUrl(box, rawUrl) {
    const url = withWidth(String(rawUrl || ""), box);
    return new Promise((resolve, reject) => {
      const img = new Image();
      try { img.fetchPriority = "high"; } catch {}
      try { img.decoding = "sync"; } catch {}
      try { img.loading = "eager"; } catch {}
      img.onload = () => resolve({ img, url });
      img.onerror = () => reject(new Error("direct URL failed"));
      img.src = url;
    });
  }
  function raceLoad(box, filename){
    const bases = ["/files/", "/cdn/shop/files/"];
    const urls  = bases.map(b => withWidth(b + encodeURIComponent(filename), box));
    return new Promise((resolve, reject)=>{
      let done=false, left = urls.length;
      const tried=[];
      urls.forEach(u=>{
        tried.push(u);
        const img = new Image();
        try{ img.fetchPriority="high"; }catch{}
        try{ img.decoding="sync"; }catch{}
        try{ img.loading="eager"; }catch{}
        img.onload = ()=>{ if(!done){ done=true; resolve({img, url:u}); } };
        img.onerror = ()=>{ if(--left===0 && !done) reject(new Error("all failed: "+tried.join(", "))); };
        img.src = u;
      });
    });
  }

  async function resolveUrlFast(box, gridSlug, styleRaw) {
    const key = `${gridSlug}__${normalizeStyleForFilename(styleRaw)}`.toLowerCase().trim();
    const liquidUrl = box.getAttribute("data-primary-url") || "";
    const liquidFile = box.getAttribute("data-primary-file") || primaryName(gridSlug, styleRaw);

    // 1) 永遠先試 Shopify Liquid 產生的版本化 URL；不讓舊 localStorage 或舊 CDN 蓋過新圖。
    if (liquidUrl) {
      try {
        const { img, url } = await loadDirectUrl(box, liquidUrl);
        cache[key] = liquidFile; saveCache();
        return { img, file: liquidFile, url, source: "liquid-versioned" };
      } catch { /* 若檔案不存在，再走舊命名備援 */ }
    }

    // 2) 試標準檔名。
    const primary = primaryName(gridSlug, styleRaw);
    try {
      const { img, url } = await raceLoad(box, primary);
      cache[key] = primary; saveCache();
      return { img, file: primary, url, source: "primary-fallback" };
    } catch {}

    // 3) 最後才讀舊快取，而且不得重複標準檔名。
    if (cache[key] && cache[key] !== primary) {
      try {
        const { img, url } = await raceLoad(box, cache[key]);
        return { img, file: cache[key], url, source: "legacy-cache" };
      } catch {}
    }

    // 4) 少量不同命名／副檔名備援。
    const fallbacks = fallbackNames(gridSlug, styleRaw);
    for (const name of fallbacks) {
      try {
        const { img, url } = await raceLoad(box, name);
        cache[key] = name; saveCache();
        return { img, file: name, url, source: "filename-fallback" };
      } catch {}
    }
    throw new Error("no match");
  }

  function mountOne(box){
    const gridRaw  = box.getAttribute("data-grid")  || "";
    const styleRaw = box.getAttribute("data-style") || "";
    const gridSlug = normalizeGridPattern(gridRaw);
    if(!gridSlug || !styleRaw){ box.style.display="none"; return; }

    if(!box.__skeleton){
      box.__skeleton=true;
      box.innerHTML='<div style="width:60%;height:8px;background:#eee;border-radius:4px;animation:pulse 1s infinite"></div>';
      if(!document.getElementById("gbg-pulse-style")){
        const st=document.createElement("style"); st.id="gbg-pulse-style";
        st.textContent="@keyframes pulse{0%{opacity:.35}50%{opacity:1}100%{opacity:.35}}";
        document.head.appendChild(st);
      }
    }

    resolveUrlFast(box, gridSlug, styleRaw).then(({img,file,url,source})=>{
      box.innerHTML="";

      // 可選寬高覆蓋
      const w = box.getAttribute("data-gbg-w");
      const h = box.getAttribute("data-gbg-h");
      if(w) box.style.width = w;
      if(h) box.style.maxHeight = h;

      // 與 SDL 同步的「百分比寬度」控制：預設 70%，可用 CSS 變數或 data 覆寫
      let pct = 80;
      const cssPct = (getComputedStyle(box).getPropertyValue("--gbg-img-pct")||"").trim();
      const attrPct = (box.getAttribute("data-gbg-pct")||"").trim();
      if(cssPct && !isNaN(parseFloat(cssPct))) pct = Math.max(10, Math.min(100, parseFloat(cssPct)));
      if(attrPct && !isNaN(parseFloat(attrPct))) pct = Math.max(10, Math.min(100, parseFloat(attrPct)));

      img.style.width = pct + "%";
      img.style.height = "auto";
      img.style.objectFit = "contain";
      img.style.maxHeight = (h || "200px"); // 與 SDL 類似的可視高度上限
      box.appendChild(img);

      try{
        box.setAttribute("data-file", file || "");
        box.setAttribute("data-source", source || "");
        box.setAttribute("data-resolved-url", url || "");
      }catch{}
    }).catch(()=>{
      box.style.display="none";
      box.innerHTML="";
    });
  }

  function mount(){ document.querySelectorAll(".cart-gbg-box").forEach(mountOne); }
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded", mount); }
  else { mount(); }
})();
